// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wz x5","ribbon":"wA yc","title":"wB x7","seasons":"wC ya","genres":"wD yb","buttonWrapper":"wE x9","button":"wF x-"};